import React from "react";
import { BsInfoCircle } from "react-icons/bs";
import { CgMediaLive } from "react-icons/cg";

const Project = ({ project, setID }) => {
  const { id, img, live } = project;

  return (
    <div className="card lg:mx-0 mx-8 border-2  max-w-lg bg-base-100 shadow-sm box rounded">
      <figure>
        <img src={img} className="w-full h-full" alt="myProject" />
      </figure>
      <div className="flex justify-center items-center writing lg:p-10 p-3 child:mb-2 lg:child:mb-3 text-white">
        <div>
          <a href={live} target="_blank" rel="noreferrer">
            <button className="myBtn-outline bg-gray-50 w-full text-center mb-3 text-xl font-[500]">
              <CgMediaLive className="mr-2" />
              Live view
            </button>
          </a>

          <label
            onClick={() => setID(id)}
            htmlFor="modal"
            className="myBtn lg:mt-4 mt-4"
          >
            <BsInfoCircle className="mr-2" />
            Show Details
          </label>
        </div>
      </div>
    </div>
  );
};

export default Project;
